import * as React from "react";

import PageWrapper from "~/common/layout/PageWrapper";
import PageContent from "~/common/layout/PageContent";

import SideMenu from "../containers/common/SideMenu";
import ProductsHeader from "../containers/products/ProductsHeader";
import ProductsHeaderTabs from "../containers/products/ProductsHeaderTabs";
import PageContentWrapper from "~/common/layout/PageContentWrapper";
import ProductList from "../containers/products/ProductList";

export default function (children: JSX.Element | null = null) {
  return (
    <React.Fragment>
      <PageWrapper>
        <SideMenu />
        <PageContent>
          <ProductsHeader />
          <ProductsHeaderTabs />
          <PageContentWrapper>
            <ProductList />
          </PageContentWrapper>
          {children}
        </PageContent>
      </PageWrapper>
    </React.Fragment>
  );
}
